/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { HomeHealthCertificationVisualReference } from './HomeHealthCertificationVisualReference';
import {
    HomeHealthCertificationVisualReferenceFromJSON,
    HomeHealthCertificationVisualReferenceFromJSONTyped,
    HomeHealthCertificationVisualReferenceToJSON,
    HomeHealthCertificationVisualReferenceToJSONTyped,
} from './HomeHealthCertificationVisualReference';

/**
 * 
 * @export
 * @interface HomeHealthCertificationReference
 */
export interface HomeHealthCertificationReference {
    /**
     * 
     */
    documentName: string;
    /**
     * 
     */
    citation: string;
    /**
     * 
     */
    visual_reference: HomeHealthCertificationVisualReference;
}

/**
 * Check if a given object implements the HomeHealthCertificationReference interface.
 */
export function instanceOfHomeHealthCertificationReference(value: object): value is HomeHealthCertificationReference {
    if (!('documentName' in value) || value['documentName'] === undefined) return false;
    if (!('citation' in value) || value['citation'] === undefined) return false;
    if (!('visual_reference' in value) || value['visual_reference'] === undefined) return false;
    return true;
}

export function HomeHealthCertificationReferenceFromJSON(json: any): HomeHealthCertificationReference {
    return HomeHealthCertificationReferenceFromJSONTyped(json, false);
}

export function HomeHealthCertificationReferenceFromJSONTyped(json: any, ignoreDiscriminator: boolean): HomeHealthCertificationReference {
    if (json == null) {
        return json;
    }
    return {
        
        'documentName': json['documentName'],
        'citation': json['citation'],
        'visual_reference': HomeHealthCertificationVisualReferenceFromJSON(json['visual_reference']),
    };
}

export function HomeHealthCertificationReferenceToJSON(json: any): HomeHealthCertificationReference {
    return HomeHealthCertificationReferenceToJSONTyped(json, false);
}

export function HomeHealthCertificationReferenceToJSONTyped(value?: HomeHealthCertificationReference | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'documentName': value['documentName'],
        'citation': value['citation'],
        'visual_reference': HomeHealthCertificationVisualReferenceToJSON(value['visual_reference']),
    };
}

